<template>
  <div>
    <b-modal id="modal_buscaExped" size="lg" :title="titulo"
        hide-header ok-only content-class="shadow"
        button-size="sm" centered ok-title="Cancelar" ok-variant="outline-primary">

        <buscaExped/>

    </b-modal>
  </div>
</template>

<script>
import buscaExped from '@/components/busca-exped.vue'
export default {
  components: {
    buscaExped,
  },
  data() {
    return {
        titulo: "Expedientes - Busqueda"
    }
  },
  computed: {
  },
  methods: {
      close() { alert('cerrar');
          this.hideModal();
      },
  }
}
</script>
